import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {BulkOperationsEvent} from "./BulkOperationsEvent";

/**
 * Created by Ibrahim Erata on 17.10.2017.
 */

@Injectable()
export class BulkOperationsService {

  public value: string;
  private eventOccuredSource:BehaviorSubject<BulkOperationsEvent> = new BehaviorSubject<BulkOperationsEvent>(new BulkOperationsEvent(false));

  eventOccured$ = this.eventOccuredSource.asObservable();
  // service command
  action(event: BulkOperationsEvent) {
    this.eventOccuredSource.next(event);
  }

  constructor() {
    this.value = "1";
  }

}
